'use client';
import { Icon } from '@fm-nx/svg';
import dynamic from 'next/dynamic';
import { useMemo } from 'react';
import SearchRefinementList from '../search-refinement-list/search-refinement-list';
const DisclosurePanel = dynamic(() => import('@headlessui/react').then((mod) => ({ default: mod.DisclosurePanel })), {
    ssr: false,
});
const Disclosure = dynamic(() => import('@headlessui/react').then((mod) => ({ default: mod.Disclosure })), {
    ssr: false,
});
const DisclosureButton = dynamic(() => import('@headlessui/react').then((mod) => ({ default: mod.DisclosureButton })), {
    ssr: false,
});
export interface SearchFiltersProps {
    index: string;
}

export function SearchFilters(props: SearchFiltersProps) {
    const { index } = props;

    const displayContentName = useMemo(() => {
        if (index.includes('case_studies')) {
            return 'Case Studies';
        }
        if (index.includes('journal')) {
            return 'Journal';
        }
        return '';
    }, [index]);

    return (
        <Disclosure>
            {({ open }) => (
                <div className="mx-6 md:grid md:mx-0 md:grid-cols-14">
                    <div className="md:col-span-12 md:col-start-2">
                        <div className={`border border-gray-900 `}>
                            <DisclosureButton
                                className={`flex justify-center w-full py-5 ${open ? 'bg-gray-900' : 'bg-white'} `}
                            >
                                <div className={`h5 mb-0 flex items-center ${open ? 'text-white' : 'text-gray-900'}`}>
                                    Filter{displayContentName ? ` ${displayContentName}` : ''}
                                    <Icon
                                        name="caret"
                                        direction={open ? 'up' : 'down'}
                                        color={open ? 'white' : 'black'}
                                    />
                                </div>
                            </DisclosureButton>
                            <DisclosurePanel unmount={false}>
                                <div className="mx-8 my-8">
                                    <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
                                        <div className="col-span-1">
                                            <h5 className="mb-4 overline h5">Service</h5>
                                            <SearchRefinementList attribute="services" />
                                        </div>
                                        <div className="col-span-1">
                                            <h5 className="mb-4 overline h5">Solution</h5>
                                            <SearchRefinementList attribute="solutions" />
                                        </div>
                                        <div className="col-span-1">
                                            <h5 className="mb-4 overline h5">Technology</h5>
                                            <SearchRefinementList attribute="technologies" />
                                        </div>
                                        {index.includes('case_studies') && (
                                            <div className="col-span-1">
                                                <h5 className="mb-4 overline h5">Industry</h5>
                                                <SearchRefinementList attribute="industries" />
                                            </div>
                                        )}
                                        {index.includes('journal') && (
                                            <div className="col-span-1">
                                                <h5 className="mb-4 overline h5">Company</h5>
                                                <SearchRefinementList attribute="companyTopics" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </DisclosurePanel>
                        </div>
                    </div>
                </div>
            )}
        </Disclosure>
    );
}

export default SearchFilters;
